import moment, { Moment } from 'moment';
import { Week } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function getDaysOfWeekQuery(this: UiQueries, week: Week): Moment[] {
  const days: Moment[] = [];
  const current = moment(week.weekId.startOfWeek); // make a copy so it is a different memory reference

  while (current <= week.weekId.endOfWeek) {
    days.push(moment(current)); // a different memory reference per day
    current.add(1, 'days');
  }

  return days;
}
